import { render, staticRenderFns } from "./IfSelectedStatusAktywnyOpConfirm.vue?vue&type=template&id=541ecfdd&"
import script from "./IfSelectedStatusAktywnyOpConfirm.vue?vue&type=script&lang=js&"
export * from "./IfSelectedStatusAktywnyOpConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VCol,VRow})
